/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

/**
 * Model to represent the GfsUserRegionMap model from the API.
 */
export class FcorgRegionMapModel {
  regionMapId: string;
  userId: string;
  region: string;
  fcorg: string;
  homeRegion: string;


  constructor(regionMapId: string, userId: string, region: string, fcorg: string, homeRegion: string) {
    this.regionMapId = regionMapId;
    this.userId = userId;
    this.region = region;
    this.fcorg = fcorg;
    this.homeRegion = homeRegion;
  }
}
